import FormPreview from '../FormPreview/FormPreview';
import { useState } from 'react';
import DialogLevelsElements from './DialogLevelsElements';
import { useSelector } from 'react-redux';

const LevelsElement = () => {
  const [modal, setModal] = useState(null);
  const featureFlag = useSelector((state) => state?.tenant?.featureFlag || {});

  return (
    <>
      {modal && (
        <DialogLevelsElements
          open={!!modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onSave={() => {}}
          type={`${modal.type}`}
          element={modal.element}
        />
      )}
      <FormPreview
        className=' '
        type={featureFlag.showLCLevelsElements ? 'levels-elements' : undefined}
        onElements={(type, element, form) => setModal({ form, type, element })}
      />
    </>
  );
};

export default LevelsElement;
